import { getApiUrl } from '@/api/apiClient.js';

const BASE = '/api/users';

export default {
  getAll: () => getApiUrl(BASE),
  getById: (id) => getApiUrl(`${BASE}/${id}`),
  blockById: (id) => getApiUrl(`${BASE}/${id}/block`),
  userRoles: (id) => getApiUrl(`${BASE}/${id}/roles`),
};
